import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from '../auth';
import {isTokenExpired} from '@core/auth/authentication-utils.service';

export const authGuard: CanActivateFn = (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const auth = inject(AuthenticationService);
  if (!isTokenExpired(auth.getToken())) {
    return true;
  }

  return redirectTo(state);
};

function redirectTo(state: RouterStateSnapshot): boolean {
  const router = inject(Router);
  router.navigate(['/loginredirect'], {queryParams: {returnUrl: state.url}});

  return false;
}
